/**
 * Bug #507
 * @Author Linda Susan Raju
 * @Date 21 Jul 2021
 */
import axios from "axios";
import { API_GET_KIOSK_FORM, API_LIST_ACTIVE_FORM, API_GET_FORM_DATA, API_SAVE_FORM_DATA, API_PATIENT_FORMS, API_FORMS_LOCK, API_FORMS_WITH_PATIENTFORMID } from 'api/endpoint';
import moment from "moment";

export const getKioskForm = () => {
  return axios.post(API_GET_KIOSK_FORM);
};

/** Bug#576 @Author: Linda Susan Raju @Date: 6 Sept 2021 */
export const getListActiveForm = (appointmentId, guid) => {
    return axios.get(API_LIST_ACTIVE_FORM, { params: {
        guid: guid,
        appointmentId: appointmentId
      }
    });
};

export const getFormData = (patientformId, formId) => {
  return axios.get(API_GET_FORM_DATA, {
    params: {
      id: patientformId,
      portalAccountFormsId:formId
        }
  });
};
/**End Bug#576 */

export const saveFormData = (formData, formEntryId, Userid, userId, locked) => {
  return axios.post(API_SAVE_FORM_DATA, {
    // formId: formId,
    // typeId: appointmentId,
    // type: type,
    filledDate: moment(new Date()).format('YYYY-MM-DDTHH:mm'),/* @Author Aby @Date 12 sept 2021 @details: change date and time format */
    ipAddress: "192.168.0.0",
    status: "true",
    patientFormData: formData,
    id: formEntryId,
    modifiedBy:Userid,
    userId:userId,
    locked:locked
  }
  );
};
/** Bug#1011 */
export const patientFormListing = (data) => {
  return axios.post(API_PATIENT_FORMS, data);
};
/** Bug #1118 */
export const patientFormsLock = (patientFormId, isLocked)=>{
  return axios.get(API_FORMS_LOCK,{
    params:{
      patientFormId :patientFormId ,
      isLocked:isLocked,
    }
  })
}
/** End Bug #1118*/
/** Bug #1153 */
export const patientFormsWithPatientFormId = (patientFormId)=>{
  return axios.get(API_FORMS_WITH_PATIENTFORMID,{
    params:{
      patientFormId :patientFormId ,
    }
  })
}
/** End Bug #1153*/